export function reduce(state, action) {
  switch (action.type) {
    case 'showMuteButton':
      return {
        ...state,
        showMuteButton: action.value
      }

    case 'showShareButtons':
      return {
        ...state,
        showShareButtons: action.value
      }

    case 'toggleMute':
      return {
        ...state,
        muted: !state.muted
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/client/reducer.js